// extracted by mini-css-extract-plugin
export var container = "_cj-0";
export var popoverContent = "_cj-1";
export var tosLink = "_cj-2";